module.exports = "<div style=height:100%> <router-view></router-view> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/layout/index.html
// module id = 620
// module chunks = 0